import React, { useEffect, useRef, useState} from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import SearchSelector from '../search-selector/';
import * as Actions from '../../redux/actions/';
import { generateId } from '../../utilities/';
import { addArtist } from "../../api/";
import './artist-selector.scss';

const ArtistSelector = ({ artistData, artists, disabled, getCollectionSubscription, label, onDeselect, onSelect }) => {
	const [isSelected, setIsSelected] = useState(artistData && artistData.name);
	const [isLoadingArtists, setIsLoadingArtists] = useState(true);
	let unsubRef = useRef(null);

	useEffect(() => {
		setIsLoadingArtists(false);
	}, [artists]);

	useEffect(() => {
		setIsLoadingArtists(true);
		unsubRef.current = getCollectionSubscription('artists');
		return () => {
			unsubRef.current && unsubRef.current();
		}
	}, [getCollectionSubscription]);

	function handleInputChange (val) {
		onSelect({id: null, name: val});
	}

	const handleArtistSearch = (val) => {
		let query;
		if (val === '') {
			query = {orderBy: ['id']};
		} else {
			query = {where: [
			  ['name', '==', val]
			]};
		}
		unsubRef.current && unsubRef.current();
		getCollectionSubscription('artists', query);
	}

	const handleArtistSelect = (selection) => {
		const artist = artists.find(artist => artist.id === selection.id);
		if (!artist) {
			console.log(`${selection.id} not found in artists`, artists);
		}
		onSelect({id: artist.id, name: artist.name});
		setIsSelected(true);
  }

	const handleArtistDeselect = (val) => {
		setIsSelected(false);
		onDeselect();
  }

  async function handleArtistAdd (data) {
		const artistId = generateId(data.value, null, data.sortByLastName);
		const newArtist = {
			id: artistId,
			name: data.value,
			albums: {}
		}
		await addArtist(newArtist);
		onSelect(newArtist);
		setIsSelected(true);
  }

	return (
		<div className="artist-selector">
		{ disabled ? (
				<div className="form-element disabled">
				<h2>Artist:</h2>
				<div className="input-wrap">
					<div className="dead-input">{artistData && artistData.name}</div>
				</div>
			</div>
		) :
			<SearchSelector
				items={artists}
				fieldIdentifier="Artist"
				label={label}
				onChange={handleInputChange}
				onSearch={handleArtistSearch}
				onSelect={handleArtistSelect}
				onDeselect={handleArtistDeselect}
				onAddClick={handleArtistAdd}
				includeSortOption
				assistiveText={{}}
				isLoading={isLoadingArtists}
				isSelected={isSelected}
				loadingText="Loading Artists..."
				searchingText="Searching Artists..."
				value={artistData}
				disabled={disabled}
			/>
		}
		</div>
	)
};

ArtistSelector.propTypes = {
	artistData: PropTypes.object,
	artists: PropTypes.array,
	disabled: PropTypes.bool,
	label: PropTypes.string,
	getCollectionSubscription: PropTypes.func,
	onSelect: PropTypes.func
}


const mapStateToProps = state => {
  return {
		artists: state.artists
	}
}

const mapDispatchToProps = {
	getCollectionSubscription: Actions.getCollectionSubscription
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps)
)(ArtistSelector)
